import React from "react";
import { motion } from "framer-motion";
import "./AdminHouse.css";
import AdminNavbar from "./AdminNavbar";

function HomePage() {
  return (
    <>
    <AdminNavbar />  
    <div className="homepage-container">
        
      {/* Background Animation */}
      <div className="background-blur"></div>

      {/* Welcome Text */}
      <motion.h3
        className="welcome-text"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Welcome To
      </motion.h3>

      {/* Main Title */}
      <motion.h1
        className="main-title"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.2 }}
      >
        HIMCHATTERJEE
      </motion.h1>

      {/* Subtitle */}
      <motion.h2
        className="subtitle"
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1.5 }}
      >
        Visual Artist
      </motion.h2>

      {/* Floating Shapes */}
      <motion.div
        className="floating-circle"
        animate={{ y: [0, -20, 0] }}
        transition={{ repeat: Infinity, duration: 4 }}
      />
      <motion.div
        className="floating-square"
        animate={{ x: [0, 20, 0] }}
        transition={{ repeat: Infinity, duration: 5 }}
      />
    </div>
    </>
  );
}

export default HomePage;
